import { render, staticRenderFns } from "./Combat.vue?vue&type=template&id=46609bde&scoped=true&"
import script from "./Combat.vue?vue&type=script&lang=js&"
export * from "./Combat.vue?vue&type=script&lang=js&"
import style0 from "./Combat.vue?vue&type=style&index=0&id=46609bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46609bde",
  null
  
)

export default component.exports